var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshdesk2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1611 21C7.44708 21 5.09006 21 3.6256 19.5355C2.16113 18.0711 2.16113 15.714 2.16113 11V7.94427C2.16113 6.1278 2.16113 5.21956 2.54145 4.53806C2.81255 4.05227 3.2134 3.65142 3.69919 3.38032C4.38069 3 5.28893 3 7.1054 3C8.26915 3 8.85103 3 9.36039 3.19101C10.5233 3.62712 11.0029 4.68358 11.5277 5.73313L12.1611 7M8.16113 7H16.9111C19.0178 7 20.0711 7 20.8278 7.50559C21.1554 7.72447 21.4366 8.00572 21.6555 8.33329C22.1611 9.08996 22.1611 10.1433 22.1611 12.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1611 15H15.1611M22.1611 18H15.1611M17.6611 21H15.1611",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshdesk2);
export default __webpack_public_path__ + "static/media/freshdesk-2.36b37f97195f7c53fac6e02a561d9821.svg";
export { ForwardRef as ReactComponent };